export default __webpack_public_path__ + "static/media/4692@3x.325e09f5.png";